import React from "react";
import { StackNavigationOptions } from "@react-navigation/stack";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import ChangePassword from "app/modules/settings/change-password/change-password";
import HomeScreen from "app/modules/home/home";
import ListTransferScreen from "app/modules/transfer/list-transfer/list-transfer";
import TransferLocal from "app/modules/transfer/transfer-local/transfer-local-create/transfer-local.web";
import TransferLocalConfirm from "app/modules/transfer/transfer-local/transfer-local-confirm/transfer-local-confirm";
import TransferLocalSuccess from "app/modules/transfer/transfer-local/transfer-local-success/transfer-local-success";
import TransferLocalAuth from "app/modules/transfer/transfer-local/transfer-local-auth/transfer-local-auth";
import TransferForeign from "app/modules/transfer/transfer-foreign/transfer-foreign-create/transfer-foreign";
import TransferForeignConfirm from "app/modules/transfer/transfer-foreign/transfer-foreign-confirm/transfer-foreign-confirm";
import TransferForeignAuth from "app/modules/transfer/transfer-foreign/transfer-foreign-auth/transfer-foreign-auth.web";
import TransferForeignSuccess from "app/modules/transfer/transfer-foreign/transfer-foreign-success/transfer-foreign-success";
import Transfer247 from "app/modules/transfer/transfer-247/transfer-247-create/transfer-247.web";
import Transfer247Confirm from "app/modules/transfer/transfer-247/transfer-247-confirm/transfer-247-confirm";
import Transfer247Auth from "app/modules/transfer/transfer-247/transfer-247-auth/transfer-247-auth";
import Transfer247Success from "app/modules/transfer/transfer-247/transfer-247-success/transfer-247-success";
import TransferStock from "app/modules/transfer/transfer-stock/transfer-stock-create/transfer-stock";
import TransferStockConfirm from "app/modules/transfer/transfer-stock/transfer-stock-confirm/transfer-stock-confirm";
import TransferStockAuth from "app/modules/transfer/transfer-stock/transfer-stock-auth/transfer-stock-auth";
import TransferStockSuccess from "app/modules/transfer/transfer-stock/transfer-stock-success/transfer-stock-success";
import TransferCharity from "app/modules/transfer/transfer-charity/transfer-charity-create/transfer-charity.web";
import TransferCharityConfirm from "app/modules/transfer/transfer-charity/transfer-charity-confirm/transfer-charity-confirm";
import TransferCharitySuccess from "app/modules/transfer/transfer-charity/transfer-charity-success/transfer-charity-success";
import TransferCharityAuth from "app/modules/transfer/transfer-charity/transfer-charity-auth/transfer-charity-auth";
import Settings from "app/modules/settings/settings";
import TopUpCreate from "app/modules/top-up/top-up-create/top-up";
import TopUpConfirm from "app/modules/top-up/top-up-confirm/top-up-confirm";
import TopUpAuth from "app/modules/top-up/top-up-auth/top-up-auth";
import TopUpSuccess from "app/modules/top-up/top-up-success/top-up-success";
import BillingsCreate from "app/modules/billings/billings-create/billings";
import BillingsConfirm from "app/modules/billings/billings-confirm/billings-confirm";
import BillingsAuth from "app/modules/billings/billings-auth/billings-auth";
import BillingsSuccess from "app/modules/billings/billings-success/billings-success";
import ListAccountManagement from "app/modules/account-management/list-account-management/list-account-management";
import InformationAccount from "app/modules/account-management/information-account/information-account";
import AccountRoll from "app/modules/account-management/account-roll/account-roll";
import DetailAccountRoll from "app/modules/account-management/account-roll/detail-account-roll/detail-account-roll";
import ListUtilities from "app/modules/utilities/list-utilities/list-utilities";
import TermDepositOpen from "app/modules/term-deposit/term-deposit-open/term-deposit-open-create/term-deposit-open-create";
import TermDepositOpenConfirm from "app/modules/term-deposit/term-deposit-open/term-deposit-open-confirm/term-deposit-open-confirm";
import TermDepositOpenAuth from "app/modules/term-deposit/term-deposit-open/term-deposit-open-auth/term-deposit-open-auth";
import TermDepositOpenSuccess from "app/modules/term-deposit/term-deposit-open/term-deposit-open-success/term-deposit-open-success";
import TermDepositStatement from "app/modules/term-deposit/term-deposit-statement/term-deposit-statement-create/term-deposit-statement-create";
import TermDepositStatementConfirm from "app/modules/term-deposit/term-deposit-statement/term-deposit-statement-confirm/term-deposit-statement-confirm";
import TermDepositStatementAuth from "app/modules/term-deposit/term-deposit-statement/term-deposit-statement-auth/term-deposit-statement-auth";
import TermDepositStatementSuccess from "app/modules/term-deposit/term-deposit-statement/term-deposit-statement-success/term-deposit-statement-success";
import TermDepositTopUp from "app/modules/term-deposit/term-deposit-top-up/term-deposit-top-up-create/term-deposit-top-up-create";
import TermDepositTopUpConfirm from "app/modules/term-deposit/term-deposit-top-up/term-deposit-top-up-confirm/term-deposit-top-up-confirm";
import TermDepositTopUpAuth from "app/modules/term-deposit/term-deposit-top-up/term-deposit-top-up-auth/term-deposit-top-up-auth";
import TermDepositTopUpSuccess from "app/modules/term-deposit/term-deposit-top-up/term-deposit-top-up-success/term-deposit-top-up-success";
import ListTermDeposit from "app/modules/term-deposit/list-term-deposit/list-term-deposit";
import ListFunctionTermDeposit from "app/modules/term-deposit/list-function-term-deposit/list-function-term-deposit";
import AutoTopUpRoll from "app/modules/auto-top-up/list-auto-top-up/auto-top-up-roll";
import AutoTopUpCreate from "app/modules/auto-top-up/auto-top-up-create/auto-top-up";
import AutoTopUpConfirm from "app/modules/auto-top-up/auto-top-up-confirm/auto-top-up-confirm";
import AutoTopUpAuth from "app/modules/auto-top-up/auto-top-up-auth/auto-top-up-auth";
import AutoTopUpSuccess from "app/modules/auto-top-up/auto-top-up-success/auto-top-up-success";
import AutoTopUpHistory from "app/modules/auto-top-up/auto-history/list-history";
import AutoBillingRoll from "app/modules/auto-billings/list-auto-billing/auto-billing-roll";
import AutoBillingCreate from "app/modules/auto-billings/auto-billings-create/auto-billings";
import AutoBillingConfirm from "app/modules/auto-billings/auto-billings-confirm/auto-billings-confirm";
import AutoBillingAuth from "app/modules/auto-billings/auto-billings-auth/auto-billings-auth";
import AutoBillingSuccess from "app/modules/auto-billings/auto-billings-success/auto-billings-success";
import AutoBillingHistory from "app/modules/auto-billings/auto-history/list-history";
import ListAboutUs from "app/modules/about-us/about-us";
import QRLibrary from "app/modules/qr-library/qr-library";
import Notifications from "app/modules/notifications/notifications";
import ListStatement from "app/modules/account-management/statement/list-statement/list-statement";
import ListTransactionHistory from "app/modules/account-management/transaction-history/list-transaction-history/list-transaction-history";
import AnswerQuestions from "app/modules/about-us/answer-questions/answer-questions";
import UserGuide from "app/modules/about-us/user-guide/user-guide";
import ListPayments from "app/modules/payments/list-payments/list-payment.web";
import ListCard from "app/modules/card-manager/list-card/list-card";
import CardAuth from "app/modules/card-manager/list-card/card-auth/card-auth";
import CardStatement from "app/modules/card-manager/card-statement/card-statement";
import CardHistory from "app/modules/card-manager/card-history/card-history";
import CardPhysicalRegister from "app/modules/card-manager/card-physical-register/card-physical-register";
import PaymentCard from "app/modules/card-manager/payment-card/payment-card-create/payment-card.web";
import PaymentCardConfirm from "app/modules/card-manager/payment-card/payment-card-confirm/payment-card-confirm.web";
import PaymentCardAuth from "app/modules/card-manager/payment-card/payment-card-auth/payment-card-auth.web";
import PaymentCardSuccess from "app/modules/card-manager/payment-card/payment-card-success/payment-card-success.web";
import PVOneWebViewComponent from "app/modules/loyalty/pv-one/pv-one-webview";

interface IRootStack {
  name: string;
  route: string;
  component: React.ComponentType<any>;
  options?: StackNavigationOptions;
  auth: boolean;
}

export const UserStack: Array<IRootStack> = [
  {
    name: ScreenNameType.HOME,
    route: ScreenNameType.HOME.toLowerCase(),
    component: HomeScreen,
    auth: true,
    options: {
      headerShown: false,
      title: "Trang chủ",
    },
  },
  {
    name: ScreenNameType.LIST_TRANSFER,
    route: ScreenNameType.LIST_TRANSFER.toLowerCase(),
    component: ListTransferScreen,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_LOCAL,
    route: ScreenNameType.TRANS_LOCAL.toLowerCase(),
    component: TransferLocal,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_LOCAL_CONFIRM,
    route: ScreenNameType.TRANS_LOCAL_CONFIRM.toLowerCase(),
    component: TransferLocalConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_LOCAL_AUTH,
    route: ScreenNameType.TRANS_LOCAL_AUTH.toLowerCase(),
    component: TransferLocalAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_LOCAL_SUCCESS,
    route: ScreenNameType.TRANS_LOCAL_SUCCESS.toLowerCase(),
    component: TransferLocalSuccess,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_FOREIGN,
    route: ScreenNameType.TRANS_FOREIGN.toLowerCase(),
    component: TransferForeign,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_FOREIGN_CONFIRM,
    route: ScreenNameType.TRANS_FOREIGN_CONFIRM.toLowerCase(),
    component: TransferForeignConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_FOREIGN_AUTH,
    route: ScreenNameType.TRANS_FOREIGN_AUTH.toLowerCase(),
    component: TransferForeignAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_FOREIGN_SUCCESS,
    route: ScreenNameType.TRANS_FOREIGN_SUCCESS.toLowerCase(),
    component: TransferForeignSuccess,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_247,
    route: ScreenNameType.TRANS_247.toLowerCase(),
    component: Transfer247,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_247_CONFIRM,
    route: ScreenNameType.TRANS_247_CONFIRM.toLowerCase(),
    component: Transfer247Confirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_247_AUTH,
    route: ScreenNameType.TRANS_247_AUTH.toLowerCase(),
    component: Transfer247Auth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_247_SUCCESS,
    route: ScreenNameType.TRANS_247_SUCCESS.toLowerCase(),
    component: Transfer247Success,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_STOCK,
    route: ScreenNameType.TRANS_STOCK.toLowerCase(),
    component: TransferStock,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_STOCK_CONFIRM,
    route: ScreenNameType.TRANS_STOCK_CONFIRM.toLowerCase(),
    component: TransferStockConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_STOCK_AUTH,
    route: ScreenNameType.TRANS_STOCK_AUTH.toLowerCase(),
    component: TransferStockAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_STOCK_SUCCESS,
    route: ScreenNameType.TRANS_STOCK_SUCCESS.toLowerCase(),
    component: TransferStockSuccess,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_CHARITY,
    route: ScreenNameType.TRANS_CHARITY.toLowerCase(),
    component: TransferCharity,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_CHARITY_CONFIRM,
    route: ScreenNameType.TRANS_CHARITY_CONFIRM.toLowerCase(),
    component: TransferCharityConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_CHARITY_AUTH,
    route: ScreenNameType.TRANS_CHARITY_AUTH.toLowerCase(),
    component: TransferCharityAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TRANS_CHARITY_SUCCESS,
    route: ScreenNameType.TRANS_CHARITY_SUCCESS.toLowerCase(),
    component: TransferCharitySuccess,
    auth: true,
    options: { headerShown: false },
  },
  // Payments
  {
    name: ScreenNameType.LIST_PAYMENTS,
    route: ScreenNameType.LIST_PAYMENTS.toLowerCase(),
    component: ListPayments,
    auth: true,
    options: { headerShown: false },
  },

  // TopUp
  {
    name: ScreenNameType.TOP_UP_CREATE,
    route: ScreenNameType.TOP_UP_CREATE.toLowerCase(),
    component: TopUpCreate,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TOP_UP_CONFIRM,
    route: ScreenNameType.TOP_UP_CONFIRM.toLowerCase(),
    component: TopUpConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TOP_UP_AUTH,
    route: ScreenNameType.TOP_UP_AUTH.toLowerCase(),
    component: TopUpAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TOP_UP_SUCCESS,
    route: ScreenNameType.TOP_UP_SUCCESS.toLowerCase(),
    component: TopUpSuccess,
    auth: true,
    options: { headerShown: false },
  },
  // Auto-Topup
  {
    name: ScreenNameType.AUTO_TOP_UP_LIST,
    route: ScreenNameType.AUTO_TOP_UP_LIST.toLowerCase(),
    component: AutoTopUpRoll,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_TOP_UP_CREATE,
    route: ScreenNameType.AUTO_TOP_UP_CREATE.toLowerCase(),
    component: AutoTopUpCreate,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_TOP_UP_CONFIRM,
    route: ScreenNameType.AUTO_TOP_UP_CONFIRM.toLowerCase(),
    component: AutoTopUpConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_TOP_UP_AUTH,
    route: ScreenNameType.AUTO_TOP_UP_AUTH.toLowerCase(),
    component: AutoTopUpAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_TOP_UP_SUCCESS,
    route: ScreenNameType.AUTO_TOP_UP_SUCCESS.toLowerCase(),
    component: AutoTopUpSuccess,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_TOP_UP_HISTORY,
    route: ScreenNameType.AUTO_TOP_UP_HISTORY.toLowerCase(),
    component: AutoTopUpHistory,
    auth: true,
    options: { headerShown: false },
  },
  // Billings
  {
    name: ScreenNameType.BILLINGS_CREATE,
    route: ScreenNameType.BILLINGS_CREATE.toLowerCase(),
    component: BillingsCreate,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.BILLINGS_CONFIRM,
    route: ScreenNameType.BILLINGS_CONFIRM.toLowerCase(),
    component: BillingsConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.BILLINGS_AUTH,
    route: ScreenNameType.BILLINGS_AUTH.toLowerCase(),
    component: BillingsAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.BILLINGS_SUCCESS,
    route: ScreenNameType.BILLINGS_SUCCESS.toLowerCase(),
    component: BillingsSuccess,
    auth: true,
    options: { headerShown: false },
  },
  // Auto-Billing
  {
    name: ScreenNameType.AUTO_BILLINGS_LIST,
    route: ScreenNameType.AUTO_BILLINGS_LIST.toLowerCase(),
    component: AutoBillingRoll,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_BILLINGS_CREATE,
    route: ScreenNameType.AUTO_BILLINGS_CREATE.toLowerCase(),
    component: AutoBillingCreate,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_BILLINGS_CONFIRM,
    route: ScreenNameType.AUTO_BILLINGS_CONFIRM.toLowerCase(),
    component: AutoBillingConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_BILLINGS_AUTH,
    route: ScreenNameType.AUTO_BILLINGS_AUTH.toLowerCase(),
    component: AutoBillingAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.AUTO_BILLINGS_SUCCESS,
    route: ScreenNameType.AUTO_BILLINGS_SUCCESS.toLowerCase(),
    component: AutoBillingSuccess,
    auth: true,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.AUTO_BILLINGS_HISTORY,
    route: ScreenNameType.AUTO_BILLINGS_HISTORY.toLowerCase(),
    component: AutoBillingHistory,
    auth: true,
    options: { headerShown: false },
  },

  // Setting
  {
    name: ScreenNameType.SETTINGS,
    route: ScreenNameType.SETTINGS.toLowerCase(),
    component: Settings,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.ChangePassword,
    route: ScreenNameType.ChangePassword.toLowerCase(),
    component: ChangePassword,
    auth: true,
    options: {
      headerShown: false,
    },
  },
  // Payment Card
  {
    name: ScreenNameType.PAYMENT_CARD_CREATE,
    route: ScreenNameType.PAYMENT_CARD_CREATE.toLowerCase(),
    component: PaymentCard,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.PAYMENT_CARD_CONFIRM,
    route: ScreenNameType.PAYMENT_CARD_CONFIRM.toLowerCase(),
    component: PaymentCardConfirm,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.PAYMENT_CARD_AUTH,
    route: ScreenNameType.PAYMENT_CARD_AUTH.toLowerCase(),
    component: PaymentCardAuth,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.PAYMENT_CARD_SUCCESS,
    route: ScreenNameType.PAYMENT_CARD_SUCCESS.toLowerCase(),
    component: PaymentCardSuccess,
    auth: true,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.INFORMATION_ACCOUNT,
    route: ScreenNameType.INFORMATION_ACCOUNT.toLowerCase(),
    component: InformationAccount,
    auth: true,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.ACCOUNT_ROLL,
    route: ScreenNameType.ACCOUNT_ROLL.toLowerCase(),
    component: AccountRoll,
    auth: true,
    options: { headerShown: false },
  },

  // Account Management
  {
    name: ScreenNameType.LIST_ACCOUNT_MANAGEMENT,
    route: ScreenNameType.LIST_ACCOUNT_MANAGEMENT.toLowerCase(),
    component: ListAccountManagement,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.DETAIL_ACCOUNT_ROLL,
    route: ScreenNameType.DETAIL_ACCOUNT_ROLL.toLowerCase(),
    component: DetailAccountRoll,
    auth: false,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT,
    route: ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT.toLowerCase(),
    component: ListFunctionTermDeposit,
    auth: false,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.LIST_UTILITIES,
    route: ScreenNameType.LIST_UTILITIES.toLowerCase(),
    component: ListUtilities,
    auth: false,
    options: { headerShown: false },
  },

  // Term-deposit: Open Passbook
  {
    name: ScreenNameType.TERM_DEPOSIT_OPEN_CREATE,
    route: ScreenNameType.TERM_DEPOSIT_OPEN_CREATE.toLowerCase(),
    component: TermDepositOpen,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TERM_DEPOSIT_OPEN_CONFIRM,
    route: ScreenNameType.TERM_DEPOSIT_OPEN_CONFIRM.toLowerCase(),
    component: TermDepositOpenConfirm,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TERM_DEPOSIT_OPEN_AUTH,
    route: ScreenNameType.TERM_DEPOSIT_OPEN_AUTH.toLowerCase(),
    component: TermDepositOpenAuth,
    auth: false,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.TERM_DEPOSIT_OPEN_SUCCESS,
    route: ScreenNameType.TERM_DEPOSIT_OPEN_SUCCESS.toLowerCase(),
    component: TermDepositOpenSuccess,
    auth: false,
    options: { headerShown: false },
  },
  // Term-deposit: Final Settlement
  {
    name: ScreenNameType.TERM_DEPOSIT_STATEMENT_CREATE,
    route: ScreenNameType.TERM_DEPOSIT_STATEMENT_CREATE.toLowerCase(),
    component: TermDepositStatement,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TERM_DEPOSIT_STATEMENT_CONFIRM,
    route: ScreenNameType.TERM_DEPOSIT_STATEMENT_CONFIRM.toLowerCase(),
    component: TermDepositStatementConfirm,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TERM_DEPOSIT_STATEMENT_AUTH,
    route: ScreenNameType.TERM_DEPOSIT_STATEMENT_AUTH.toLowerCase(),
    component: TermDepositStatementAuth,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TERM_DEPOSIT_STATEMENT_SUCCESS,
    route: ScreenNameType.TERM_DEPOSIT_STATEMENT_SUCCESS.toLowerCase(),
    component: TermDepositStatementSuccess,
    auth: false,
    options: { headerShown: false },
  },

  // Term-deposit: recharged into Passbook
  {
    name: ScreenNameType.TERM_DEPOSIT_TOP_UP_CREATE,
    route: ScreenNameType.TERM_DEPOSIT_TOP_UP_CREATE.toLowerCase(),
    component: TermDepositTopUp,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TERM_DEPOSIT_TOP_UP_CONFIRM,
    route: ScreenNameType.TERM_DEPOSIT_TOP_UP_CONFIRM.toLowerCase(),
    component: TermDepositTopUpConfirm,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.TERM_DEPOSIT_TOP_UP_AUTH,
    route: ScreenNameType.TERM_DEPOSIT_TOP_UP_AUTH.toLowerCase(),
    component: TermDepositTopUpAuth,
    auth: false,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.TERM_DEPOSIT_TOP_UP_SUCCESS,
    route: ScreenNameType.TERM_DEPOSIT_TOP_UP_SUCCESS.toLowerCase(),
    component: TermDepositTopUpSuccess,
    auth: false,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.LIST_TERM_DEPOSIT,
    route: ScreenNameType.LIST_TERM_DEPOSIT.toLowerCase(),
    component: ListTermDeposit,
    auth: false,
    options: { headerShown: false },
  },
  // Dịch vụ thẻ
  {
    name: ScreenNameType.LIST_CARDS,
    route: ScreenNameType.LIST_CARDS.toLowerCase(),
    component: ListCard,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.CARD_AUTH,
    route: ScreenNameType.CARD_AUTH.toLowerCase(),
    component: CardAuth,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.CARD_STATEMENT,
    route: ScreenNameType.CARD_STATEMENT.toLowerCase(),
    component: CardStatement,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.CARD_HISTORY,
    route: ScreenNameType.CARD_HISTORY.toLowerCase(),
    component: CardHistory,
    auth: false,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.CARD_PHYSICAL_HISTORY,
    route: ScreenNameType.CARD_PHYSICAL_HISTORY.toLowerCase(),
    component: CardPhysicalRegister,
    auth: false,
    options: { headerShown: false },
  },

  // Statement
  {
    name: ScreenNameType.LIST_STATEMENT,
    route: ScreenNameType.LIST_STATEMENT.toLowerCase(),
    component: ListStatement,
    auth: true,
    options: { headerShown: false },
  },

  // Lịch sử giao dịch
  {
    name: ScreenNameType.LIST_TRANSACTION_HISTORY,
    route: ScreenNameType.LIST_TRANSACTION_HISTORY.toLowerCase(),
    component: ListTransactionHistory,
    auth: true,
    options: { headerShown: false },
  },

  // About Us
  {
    name: ScreenNameType.LIST_ABOUT_US,
    route: ScreenNameType.LIST_ABOUT_US.toLowerCase(),
    component: ListAboutUs,
    auth: true,
    options: { headerShown: false },
  },
  {
    name: ScreenNameType.ANSWER_QUESTIONS,
    route: ScreenNameType.ANSWER_QUESTIONS.toLowerCase(),
    component: AnswerQuestions,
    auth: true,
  },
  {
    name: ScreenNameType.USER_GUIDE,
    route: ScreenNameType.USER_GUIDE.toLowerCase(),
    component: UserGuide,
    auth: true,
  },

  // QR-LIBRARY
  {
    name: ScreenNameType.QR_LIBRARY,
    route: ScreenNameType.QR_LIBRARY.toLowerCase(),
    component: QRLibrary,
    auth: true,
    options: { headerShown: false },
  },

  {
    name: ScreenNameType.NOTIFICATIONS,
    route: ScreenNameType.NOTIFICATIONS.toLowerCase(),
    component: Notifications,
    auth: true,
  },

  // Loyalty
  {
    name: ScreenNameType.PV_ONE,
    route: ScreenNameType.PV_ONE.toLowerCase(),
    component: PVOneWebViewComponent,
    auth: true,
    options: { headerShown: false },
  },
];
